module.exports = __webpack_public_path__ + "static/media/PM47.689e8507.JPG";